import {ToastMessageOptions, useToast} from 'primevue'
import {NotificationHandlers, PracsysErrorNotification, PracsysNotification} from '@/services/infrastructure/notification.service'

export const useToastNotification = () => {
    const toast = useToast()

    const renderSuccess = ({title, description}: PracsysNotification) => {
        toast.add({severity: 'success', life: 3000, summary: title, detail: description} as Partial<ToastMessageOptions>)
    }

    const renderError = ({title, description}: PracsysErrorNotification) => {
        let detailText: string = ''
        if (typeof description !== 'string') {
            detailText = description.descriptionMessage
            console.error(description.descriptionMessage, description.error)
        } else {
            detailText = description
        }
        console.error('An error ocurred', description)
        toast.add({severity: 'error', life: 10_000, summary: title, detail: detailText} as Partial<ToastMessageOptions>)
    }

    const renderWarning = ({title, description}: PracsysNotification) => {
        toast.add({severity: 'warn', life: 3000, summary: title, detail: description} as Partial<ToastMessageOptions>)
    }

    const renderInfo = ({title, description}: PracsysNotification) => {
        toast.add({severity: 'info', life: 3000, summary: title, detail: description} as Partial<ToastMessageOptions>)
    }

    const notificationRenderers: NotificationHandlers = {
        notifySuccess: renderSuccess,
        notifyError: renderError,
        notifyWarning: renderWarning,
        notifyInfo: renderInfo
    }

    return {notificationRenderers}
}